import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  type ServiceLink = { label: string; to?: string; href?: string };

  const servicesDropdown: ServiceLink[] = [
    { label: "VENTA DE EQUIPOS DE CLIMATIZACIÓN", to: "/servicios/venta-de-equipos" },
    { label: "INSTALACIÓN DE AIRES ACONDICIONADOS", to: "/servicios/instalacion-aires" },
    { label: "MANTENIMIENTO PARA AIRES ACONDICIONADOS Y CUARTOS FRÍOS", to: "/servicios/mantenimiento-cuartos-frios" },
    { label: "VENTILACIÓN MECÁNICA", to: "/servicios/ventilacion-mecanica" },
    { label: "CUARTOS FRÍOS", to: "/servicios/cuartos-frios" },
    { label: "DISEÑO E INGENIERÍA BIM EN REVIT", to: "/servicios/diseno-revit-bim" },
  ];

  const topBarHeight = "h-9 md:h-10";

  return (
    <>
      {/* Top Info Bar */}
      <div
        className={`fixed top-0 left-0 right-0 z-[60] ${topBarHeight} bg-primary-950 flex items-center px-4 md:px-8 lg:px-12`}
      >
        <div className="flex items-center justify-between w-full text-background-50 text-xs">
          <div className="hidden md:flex items-center gap-5">
            <a
              href="mailto:ventas@serin.com.co"
              className="flex items-center gap-1.5 hover:text-accent-300 transition-colors"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
              <span className="hidden lg:inline">ventas@serin.com.co</span>
            </a>
            <a
              href="mailto:ingenieria@serin.com.co"
              className="flex items-center gap-1.5 hover:text-accent-300 transition-colors"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
              <span className="hidden lg:inline">ingenieria@serin.com.co</span>
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Cll%2070A%20%2316%20-%2049%20Bogot%C3%A1%20D.C."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 hover:text-accent-300 transition-colors"
            >
              <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
              <span>Dirección: Cll 70A #16 - 49</span>
            </a>
            <a
              href="https://wa.link/0adpkz"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 hover:text-accent-300 transition-colors"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              <span>323 220 9100</span>
            </a>
            <a
              href="https://wa.link/b002hg"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 hover:text-accent-300 transition-colors"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              <span>350 588 8898</span>
            </a>
          </div>
          <div className="flex md:hidden items-center gap-2 text-background-50">
            <a
              href="https://wa.link/0adpkz"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 hover:text-accent-300 transition-colors"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              <span>323 220 9100</span>
            </a>
            <a
              href="https://wa.link/b002hg"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 hover:text-accent-300 transition-colors"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              <span>350 588 8898</span>
            </a>
          </div>
          <div className="flex items-center gap-3 md:ml-auto">
            <a
              href="https://www.facebook.com/profile.php?id=61585515711369"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent-300 transition-colors"
              aria-label="Facebook"
            >
              <i className="ri-facebook-fill w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="https://www.instagram.com/airesacondicionados.serin"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent-300 transition-colors"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="https://wa.link/0adpkz"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent-300 transition-colors"
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav
        className={`fixed top-9 md:top-10 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
            : "bg-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-24 md:h-28">
            {/* Logo */}
            <a href="/" className="flex items-center gap-2 group">
              <img
                src="https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/9291d9ab-10da-42a6-b94f-73112785d5bd_compressed_Diseo-sin-ttulo-3.webp"
                alt="SERIN Ingeniería de Proyectos SAS"
                className="h-12 md:h-24 w-auto object-contain"
              />
            </a>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-1 lg:gap-2">
              <a
                href="/"
                className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-200 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                Inicio
              </a>
              <a
                href="#nosotros"
                className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-200 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                Nosotros
              </a>

              {/* Servicios Dropdown */}
              <div className="relative group">
                <button
                  className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer ${
                    scrolled
                      ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                      : "text-background-200 hover:text-background-50 hover:bg-white/10"
                  }`}
                >
                  Servicios
                  <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center" />
                </button>
                <div className="absolute top-full left-0 mt-1 w-80 bg-background-50 rounded-xl shadow-xl border border-background-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 overflow-hidden">
                  {servicesDropdown.map((item) =>
                    item.to ? (
                      <Link
                        key={item.label}
                        to={item.to}
                        className="block px-4 py-3.5 text-sm font-semibold text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors border-b border-background-100 last:border-b-0"
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a
                        key={item.label}
                        href={item.href}
                        className="block px-4 py-3.5 text-sm font-semibold text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors border-b border-background-100 last:border-b-0"
                      >
                        {item.label}
                      </a>
                    )
                  )}
                </div>
              </div>

              <a
                href="#contacto"
                className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-200 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                Contacto
              </a>
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-3">
              <a
                href="https://wa.link/0adpkz"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${
                  scrolled
                    ? "bg-primary-100 text-primary-600 hover:bg-primary-200"
                    : "bg-white/10 text-background-50 hover:bg-white/20"
                }`}
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center" />
              </a>
              <a
                href="https://wa.link/b002hg"
                className="px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-bold hover:bg-accent-600 transition-colors whitespace-nowrap shadow-lg shadow-accent-500/20"
              >
                COTIZA AHORA
              </a>
            </div>

            {/* Mobile Toggle */}
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <i
                className={`text-2xl transition-colors w-6 h-6 flex items-center justify-center ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
              />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70 px-4 py-4">
            <div className="flex flex-col gap-1">
              <a
                href="/"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-lg text-foreground-800 font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                Inicio
              </a>
              <a
                href="#nosotros"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-lg text-foreground-800 font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                Nosotros
              </a>

              {/* Mobile Servicios Dropdown */}
              <div>
                <button
                  onClick={() => setServicesOpen(!servicesOpen)}
                  className="w-full px-4 py-3 rounded-lg text-foreground-800 font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors flex items-center justify-between cursor-pointer"
                >
                  Servicios
                  <i
                    className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform ${
                      servicesOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {servicesOpen && (
                  <div className="pl-4 mt-1 border-l-2 border-accent-200 ml-4">
                    {servicesDropdown.map((item) =>
                      item.to ? (
                        <Link
                          key={item.label}
                          to={item.to}
                          onClick={() => setMobileOpen(false)}
                          className="block px-4 py-2.5 text-sm font-semibold text-foreground-700 hover:text-accent-600 transition-colors"
                        >
                          {item.label}
                        </Link>
                      ) : (
                        <a
                          key={item.label}
                          href={item.href}
                          onClick={() => setMobileOpen(false)}
                          className="block px-4 py-2.5 text-sm font-semibold text-foreground-700 hover:text-accent-600 transition-colors"
                        >
                          {item.label}
                        </a>
                      )
                    )}
                  </div>
                )}
              </div>

              <a
                href="#contacto"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-lg text-foreground-800 font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                Contacto
              </a>
              <div className="mt-3 pt-3 border-t border-background-200 flex flex-col gap-3">
                <a
                  href="https://wa.link/0adpkz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-3 rounded-lg bg-primary-50 text-primary-700 font-medium"
                >
                  <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center" />
                  Escribir por WhatsApp
                </a>
                <a
                  href="https://wa.link/b002hg"
                  onClick={() => setMobileOpen(false)}
                  className="px-4 py-3 rounded-lg bg-accent-500 text-background-50 text-center font-bold shadow-lg shadow-accent-500/20"
                >
                  COTIZA AHORA
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}